"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformEnvironment = void 0;
exports.PlatformEnvironment = {
    Production: {
        auth: "https://auth.api.speechify.com",
        books: "https://books.api.speechify.com",
        voice: "https://vms.api.speechify.com",
        payment: "https://payment.api.speechify.com",
        entitlement: "https://entitlement.api.speechify.com",
        userProfile: "https://user-profile.api.speechify.com",
        integration: "https://integration.api.speechify.com",
        llm: "https://llm.api.speechify.com",
        teams: "https://teams.api.speechify.com",
        catalog: "https://catalog.api.speechify.com",
    },
    Development: {
        auth: "https://auth.api.speechify.dev",
        books: "https://books.api.speechify.dev",
        voice: "https://vms.api.speechify.dev",
        payment: "https://payment.api.speechify.dev",
        entitlement: "https://entitlement.api.speechify.dev",
        userProfile: "https://user-profile.api.speechify.dev",
        integration: "https://integration.api.speechify.dev",
        llm: "https://llm.api.speechify.dev",
        teams: "https://teams.api.speechify.dev",
        catalog: "https://catalog.api.speechify.dev",
    },
};
